import React from 'react';
import RoutesIndex from './routes';

function App() {
  return (
    <RoutesIndex />
  );
}

export default App;
